<div class="usage-bar">
   <!--<strong> {{leftText}} <span class="pull-right" [ngClass]="{'pull-left': valueDirection == 'left'}">{{dynamicValue}} of {{totalValue}} {{rightText}} </span></strong>-->
  <strong *ngIf="valueDirection == '' || valueDirection == undefined"> {{leftText}} <span class="pull-right">{{dynamicValue}} of {{totalValue}} {{rightText}} </span></strong>
  <strong *ngIf="valueDirection == 'left'">{{dynamicValue}} of {{totalValue}} {{rightText}} {{leftText}}</strong>
</div>
<div class="progress">
  <div class="progress-bar" [style.width.%]="barWidth"></div>
</div>
